import { useSettings } from "@/context/SettingsContext";
import { goUrl, trackClick } from "@/lib/api";
import { ExternalLink, Sparkles } from "lucide-react";

export default function BookmakerCard({ bm }) {
  const s = useSettings();
  return (
    <article
      data-testid={`bookmaker-card-${bm.slug}`}
      className="relative flex flex-col rounded-2xl border border-white/10 bg-gradient-to-b from-[#141414] to-[#0F0F0F] p-6 sm:p-7 transition-transform duration-200 hover:-translate-y-1 hover:border-yellow-400/40 group"
    >
      {bm.featured && (
        <span className="absolute top-4 right-4 inline-flex items-center gap-1 rounded-full bg-yellow-400 text-black text-[10px] font-bold uppercase px-2.5 py-1 tracking-widest">
          <Sparkles className="w-3 h-3" /> In evidenza
        </span>
      )}
      {bm.is_new && !bm.featured && (
        <span className="absolute top-4 right-4 inline-flex items-center rounded-full bg-white/10 border border-white/15 text-white text-[10px] font-bold uppercase px-2.5 py-1 tracking-widest">
          Nuova
        </span>
      )}

      <div className="flex items-center gap-3 mb-4">
        {bm.logo_url ? (
          <img src={bm.logo_url} alt={bm.name} className="h-11 w-11 rounded-lg object-contain bg-white/5 p-1" />
        ) : (
          <div className="h-11 w-11 rounded-lg bg-yellow-400/10 border border-yellow-400/30 grid place-items-center text-yellow-400 font-black text-lg">
            {bm.name?.charAt(0)}
          </div>
        )}
        <div>
          <h3 className="text-xl font-bold tracking-tight text-white flex items-center gap-2">
            {bm.name} <span>{bm.accent_emoji}</span>
          </h3>
          <p className="text-xs uppercase tracking-widest text-yellow-500">
            Bookmaker partner
          </p>
        </div>
      </div>

      <div className="mb-3">
        <div className="text-[11px] uppercase tracking-widest text-zinc-500 mb-1">
          Promozione
        </div>
        <div className="text-lg font-semibold text-yellow-400">
          {bm.promo_title}
        </div>
      </div>

      <p className="text-sm text-zinc-400 mb-4 leading-relaxed">
        {bm.short_description}
      </p>

      {bm.conditions?.length > 0 && (
        <ul className="mb-6 space-y-1.5 text-sm text-zinc-300">
          {bm.conditions.map((c, i) => (
            <li key={i} className="flex items-start gap-2">
              <span className="mt-1.5 h-1.5 w-1.5 rounded-full bg-yellow-400 shrink-0" />
              <span>{c}</span>
            </li>
          ))}
        </ul>
      )}

      <div className="mt-auto flex flex-col sm:flex-row gap-2">
        <a
          href={goUrl(bm.slug)}
          target="_blank"
          rel="noreferrer noopener"
          data-testid={`bookmaker-signup-${bm.slug}`}
          className="flex-1 inline-flex items-center justify-center gap-2 rounded-full bg-yellow-400 hover:bg-yellow-300 text-black font-bold text-sm px-4 py-3 transition-transform duration-200 hover:scale-[1.02]"
        >
          REGISTRATI SU {bm.name.toUpperCase()}
          <ExternalLink className="w-4 h-4" />
        </a>
        <a
          href={s.whatsapp_url}
          target="_blank"
          rel="noopener"
          onClick={() => trackClick("whatsapp")}
          data-testid={`bookmaker-help-${bm.slug}`}
          className="inline-flex items-center justify-center rounded-full border border-white/15 hover:border-yellow-400 hover:text-yellow-400 text-white font-medium text-sm px-4 py-3 transition-colors duration-200"
        >
          Assistenza
        </a>
      </div>
    </article>
  );
}
